export const postImportEmployeesIS = {
	settings: null,
	error: null,
	errorShow: false,
	loading: false,
	isImported: false,
};
